import PageHero from "../components/PageHero";
import SEO from "../components/SEO";

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO
        title="Hakkımızda"
        description="Darkın ailesi olarak 2019'dan beri elektrikli ürün tedariği yapmaktayız. Fardriver Türkiye tedarikçisi."
        path="/hakkimizda"
      />
      <PageHero
        overline="Hakkımızda"
        title="Darkın ailesi olarak yanınızdayız."
        description="Darkın ailesi olarak 2019'dan beri elektrikli ürün tedariği yapmaktayız."
      />

      <section className="max-w-3xl mx-auto px-6 py-20">
        <p className="text-lg text-gray-700 leading-relaxed">
          Darkın ailesi olarak 2019 yılından bu yana elektrikli ürün tedariği alanında faaliyet
          gösteriyoruz. Fardriver kontrolör portföyünün Türkiye'deki tedarikçisi olarak; ürün temini,
          teknik danışmanlık ve satış sonrası destek hizmetlerini tek çatı altında topluyoruz.
        </p>
      </section>
    </div>
  );
}
